import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function OutwardArrowIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 16 17" htmlColor={Color.Body} {...props}>
      <path d="M10.7628 5.20252L4.54102 11.4179C4.44871 11.5102 4.33269 11.5553 4.19295 11.5532C4.05321 11.551 3.93719 11.5038 3.84489 11.4115C3.75258 11.3192 3.70642 11.2042 3.70642 11.0666C3.70642 10.929 3.75258 10.8141 3.84489 10.7218L10.0603 4.49997H4.59615C4.45449 4.49997 4.33574 4.45203 4.2399 4.35617C4.14408 4.26029 4.09617 4.14149 4.09617 3.99977C4.09617 3.85803 4.14408 3.73931 4.2399 3.64358C4.33574 3.54786 4.45449 3.5 4.59615 3.5H11.1603C11.331 3.5 11.4741 3.55775 11.5896 3.67323C11.7051 3.78872 11.7628 3.93183 11.7628 4.10255V10.6667C11.7628 10.8083 11.7149 10.9271 11.619 11.0229C11.5231 11.1187 11.4043 11.1666 11.2626 11.1666C11.1209 11.1666 11.0021 11.1187 10.9064 11.0229C10.8107 10.9271 10.7628 10.8083 10.7628 10.6667V5.20252Z" />
    </MuiSvgIcon>
  );
}
export default OutwardArrowIcon;
